"use client";

/**
 * The main window's half of the Dock window bridge (spec 2026-09-22 §4):
 * performs the navigation the panel's Line asked for, through the same belt
 * LineActions uses. Renderless; inert on the web (no shell, no listener).
 */
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { performRouterAction } from "@/components/composer/routerActions";
import { onDockAction } from "@/lib/dock-window";

export function DockActionRelay() {
  const router = useRouter();
  useEffect(
    () => onDockAction((action) => performRouterAction(action, router)),
    [router]
  );
  return null;
}
